import { FormStatusEnum } from '../types/enums/form-status.enum';

// Synthetic, frontend-only marker — never sent to or received from the backend. FormStatusEnum's
// own IN_PROCESS means "the wizard itself isn't finished yet" (bucketed as "Sin completar" like
// any other incomplete status). A FINISHED business with an unsigned contract is a different,
// more specific situation — waiting on a signature, not on the form — so it needs its own value
// instead of colliding with raw IN_PROCESS and inheriting its text/color.
export const CONTRACT_SIGNATURE_PENDING_STATUS = 'CONTRACT_SIGNATURE_PENDING';

export const getStatusStyle = (status: string | FormStatusEnum) => {
  switch (status) {
    case FormStatusEnum[FormStatusEnum.FINISHED]:
    case FormStatusEnum[FormStatusEnum.DOCS_SIGNED]:
    case FormStatusEnum[FormStatusEnum.SIGNED]:
    case FormStatusEnum[FormStatusEnum.NOT_SENDED]:
      return 'status-green';

    case FormStatusEnum[FormStatusEnum.STARTED_BY_OTHER]:
      return 'status-yellow';

    case CONTRACT_SIGNATURE_PENDING_STATUS:
      return 'status-orange';

    default:
      return 'status-red';
  }
};

export const getStatusValue = (status: string | FormStatusEnum) => {
  switch (status) {
    case FormStatusEnum[FormStatusEnum.FINISHED]:
      return 'Finalizado';

    case FormStatusEnum[FormStatusEnum.STARTED_BY_OTHER]:
      return 'Enviado a firmar';

    case CONTRACT_SIGNATURE_PENDING_STATUS:
      return 'Pendiente de firma';

    case FormStatusEnum[FormStatusEnum.DOCS_SIGNED]:
    case FormStatusEnum[FormStatusEnum.SIGNED]:
    case FormStatusEnum[FormStatusEnum.NOT_SENDED]:
      return 'Firmado';

    case FormStatusEnum[FormStatusEnum.PENDING]:
      return 'Enviado a firmar';

    default:
      return 'Sin completar';
  }
};

// A business can be FINISHED (the wizard/form was fully filled) while its contracts are still
// pending signature. Mirrors SearchCommerce's generateStatus() so any screen listing onboardings
// shows the same effective status instead of trusting the raw FINISHED flag on its own.
export const getEffectiveOnboardingStatus = (
  status: string,
  contracts: Array<{ vaFirmaStatus?: string }> = [],
) => {
  if (status !== FormStatusEnum[FormStatusEnum.FINISHED]) return status;

  const contractsAreSigned = contracts.every(
    (contract) => contract.vaFirmaStatus === 'SIGNED' || contract.vaFirmaStatus === 'NOT_SENDED',
  );

  return contractsAreSigned ? FormStatusEnum[FormStatusEnum.FINISHED] : CONTRACT_SIGNATURE_PENDING_STATUS;
};
